
import { useSettings } from "@/providers/SettingsProvider";
import { AlertCircle } from "lucide-react";
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";

export const AIStatusBanner = () => {
  try {
    const { aiDisabled } = useSettings();
    
    if (!aiDisabled) return null;
    
    return (
      <Alert variant="destructive" className="bg-red-50 border border-red-200 mb-6 rounded-sm">
        <AlertCircle className="h-4 w-4 text-red-600" />
        <AlertTitle className="text-red-600 font-medium">AI Features Disabled</AlertTitle>
        <AlertDescription className="text-red-700">
          AI features are currently disabled. Some functionality may be limited.
        </AlertDescription>
      </Alert>
    );
  } catch (error) {
    // If there's an error with the settings context, don't show the banner
    console.error("Error in AIStatusBanner:", error);
    return null;
  }
};
